export { default } from './VoteContainer';
